/**
 * Contains methods for animation, that `cash-dom` doesn't have.
 * >Note: add more method if need.
 */
const animate = {
  /**
   * Fades in.
   * @param {Cash|string} selector
   * @param {number} transitionTime Transition time in ms.
   */
  fadeIn(selector, transitionTime = 200) {
    const $selector = $(selector);

    if (!$selector.length) {
      return;
    }

    $selector
      .css('opacity', 0)
      .show()
      .css('transition', 'opacity ' + transitionTime + 'ms');

    setTimeout(() => $selector.css('opacity', 1), 0);
  },

  /**
   * Fades out.
   * @param {Cash|string} selector
   * @param {number} transitionTime Transition time in ms.
   */
  fadeOut: function (selector, transitionTime = 200) {
    const $selector = $(selector);

    $selector
      .css('transition', 'opacity ' + transitionTime + 'ms')
      .css('opacity', 0);

    setTimeout(() => {
      $selector.hide();
    }, transitionTime);
  },

  /**
   * Fades out.
   * @param {Cash} $currentElement Current Cash to be replaced (fadeOut).
   * @param {Cash} $newElement New Cash to be set (fadeIn).
   * @param {number} transitionTime Transition time in ms.
   */
  fadeReplace($currentElement, $newElement) {
    $currentElement.after($newElement);

    this.fadeOut($currentElement, 0);
    this.fadeIn($newElement, 0);

    $currentElement.remove();
  },

  scrollToTop: function (top) {
    window.scroll({top: top, left: 0, behavior: 'smooth'});
  },

  scrollToElement: function ($element) {
    $element = $($element);
    const element = $element.get(0);

    if (!element) {
      return;
    }

    const top = element.getBoundingClientRect().top + window.scrollY

    window.scroll({top: top, left: 0, behavior: 'smooth'});
  },

  slideToggle: function(element, duration, callback) {
    if (element.clientHeight === 0) {
      this._slide(element, duration, callback, true);
    } else {
      this._slide(element, duration, callback);
    }
  },

  slideUp: function(element, duration, callback) {
    this._slide(element, duration, callback);
  },

  slideDown: function (element, duration, callback) {
    this._slide(element, duration, callback, true);
  },

  _slide: function (el, duration, callback, isDown) {

    if (typeof duration === 'undefined') duration = 400;
    if (typeof isDown === 'undefined') isDown = false;

    el.style.overflow = "hidden";
    if (isDown) el.style.display = "block";

    const elStyles = window.getComputedStyle(el);

    const elHeight = parseFloat(elStyles.getPropertyValue('height'));
    const elPaddingTop = parseFloat(elStyles.getPropertyValue('padding-top'));
    const elPaddingBottom = parseFloat(elStyles.getPropertyValue('padding-bottom'));
    const elMarginTop = parseFloat(elStyles.getPropertyValue('margin-top'));
    const elMarginBottom = parseFloat(elStyles.getPropertyValue('margin-bottom'));

    const stepHeight = elHeight / duration;
    const stepPaddingTop = elPaddingTop / duration;
    const stepPaddingBottom = elPaddingBottom / duration;
    const stepMarginTop = elMarginTop / duration;
    const stepMarginBottom = elMarginBottom / duration;

    let start;

    function step(timestamp) {

      if (start === undefined) start = timestamp;

      const elapsed = timestamp - start;

      if (isDown) {
        el.style.height        = (stepHeight        * elapsed) + "px";
        el.style.paddingTop    = (stepPaddingTop    * elapsed) + "px";
        el.style.paddingBottom = (stepPaddingBottom * elapsed) + "px";
        el.style.marginTop     = (stepMarginTop     * elapsed) + "px";
        el.style.marginBottom  = (stepMarginBottom  * elapsed) + "px";
      } else {
        el.style.height        = elHeight        - (stepHeight        * elapsed) + "px";
        el.style.paddingTop    = elPaddingTop    - (stepPaddingTop    * elapsed) + "px";
        el.style.paddingBottom = elPaddingBottom - (stepPaddingBottom * elapsed) + "px";
        el.style.marginTop     = elMarginTop     - (stepMarginTop     * elapsed) + "px";
        el.style.marginBottom  = elMarginBottom  - (stepMarginBottom  * elapsed) + "px";
      }

      if (elapsed >= duration) {
        el.style.height        = "";
        el.style.paddingTop    = "";
        el.style.paddingBottom = "";
        el.style.marginTop     = "";
        el.style.marginBottom  = "";
        el.style.overflow      = "";
        if (!isDown) el.style.display = "none";
        if (typeof callback === 'function') callback();
      } else {
        window.requestAnimationFrame(step);
      }
    }

    window.requestAnimationFrame(step);
  }
};
